// ══════════════════════════════════════════════════════
//  extractors/socialMomentum.js — 社交热度
//
//  源：CoinGecko community_data + watchlist_portfolio_users
//      + Surf mindshare 时序（如可用，在前端 hook 中拉取）
// ══════════════════════════════════════════════════════

import { safeNum, pick } from './_shared';

export function isAvailable(project) {
  return !!safeNum(pick(project, 'cgData.community_data.twitter_followers'))
      || !!safeNum(pick(project, 'cgData.watchlist_portfolio_users'));
}

export function extract(project /* , a */) {
  const cd = pick(project, 'cgData.community_data') || {};
  const twitter = safeNum(cd.twitter_followers);
  const telegram = safeNum(cd.telegram_channel_user_count);
  const reddit = safeNum(cd.reddit_subscribers);
  const watchlist = safeNum(pick(project, 'cgData.watchlist_portfolio_users'));
  const sentiment = safeNum(pick(project, 'cgData.sentiment_votes_up_percentage'));

  if (twitter == null && watchlist == null && telegram == null && reddit == null) return null;

  return {
    twitterFollowers: twitter,
    telegramSubscribers: telegram,
    redditSubscribers: reddit,
    watchlistUsers: watchlist,
    bullishSentimentPct: sentiment,  // 0~100
  };
}
